import type { FireflyRuntime, NavigationLinkAdditionalProps } from "@sg-protect/federation-runtime";
import type { ReactNode } from "react";
import { ProtectSidebarBottomId, ProtectSidebarId } from "./constants.ts";

export interface ProtectSidebarItemOptions {
    id: string;
    label: string;
    to: string;
    icon: ReactNode;
    priority: number;
    badge?: ReactNode;
}

export function registerProtectSidebarItem(
    runtime: FireflyRuntime,
    { id, label, to, icon, priority, badge }: ProtectSidebarItemOptions
) {
    runtime.registerNavigationItem(
        {
            $id: id,
            $label: label,
            to,
            $priority: priority,
            $additionalProps: {
                icon,
                badge
            } satisfies NavigationLinkAdditionalProps
        },
        {
            menuId: ProtectSidebarId
        }
    );
}

export function registerProtectSidebarBottomItem(
    runtime: FireflyRuntime,
    { id, label, to, icon, priority, badge }: ProtectSidebarItemOptions
) {
    runtime.registerNavigationItem(
        {
            $id: id,
            $label: label,
            to,
            $priority: priority,
            $additionalProps: {
                icon,
                badge
            } satisfies NavigationLinkAdditionalProps
        },
        {
            menuId: ProtectSidebarBottomId
        }
    );
}
